export enum TenantStatusEnum {
    PENDING = 'pending',
    ACTIVE = 'active',
    DEACTIVATED = 'deactivated',
}
